// Editor för TwoColumnsBlock — själva inner-blocks redigeras direkt på canvas.
// Här visar vi bara en hjälptext.

import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const TwoColumnsBlockEditor = () => {
  const { t } = useTranslation('groupMessage');
  return (
    <Stack spacing={1}>
      <Typography variant='body2' color='text.secondary'>
        {t('builder.editors.twoColumnsHint')}
      </Typography>
    </Stack>
  );
};

export default TwoColumnsBlockEditor;
